var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"subtitle-2 white--text",attrs:{"color":_vm.ratingColor}},[_vm._v(" "+_vm._s(_vm.score)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }